
(function(template){
    define('vue!app/views/vue/components/packageDivComponent/packageSelectionComponent/packageItemDetails',['Vue','helpers'],function(Vue,helpers){
        return {
            template: template,
            props: ['image','desc','clientInfo'],
             methods: {
                MarkDownDesc:function(text){
                    return helpers.nl2br(text)
                },
                handleLoadedImage:function(e){
                    e.target.style.display= "block"
                    e.target.parentElement.classList.remove('nongrid-img-dec')
                }
             },
        }
    })
})('<div class="package-item-img-dec-holder nongrid-img-dec"> <img :src="image" @load="handleLoadedImage" style="display:none" alt="Image for package item"/> <div> <p v-html="MarkDownDesc(desc)"></p> <div class="service-details-clientInstruction" v-html="MarkDownDesc(clientInfo)" ></div> </div> </div>');
